import ControlArea from "components/Layout/ControlArea";
import React from "react";
import { useSelector } from "react-redux";
import blogIcon from "assets/svgs/blog.svg";
import Table from "./Table";
import BootyPagination from "components/shared/Pagination";
import UpdateHeading from "views/ourServices/UpdateHeading";
const Blogs = () => {
  const { services, metadata } = useSelector((state) => state.services);

  return (
    <>
      <div className="stores-wrap">
        <ControlArea
          btnTxt="اضافة خدمة"
          cardTxt="الخدمات"
          icon={blogIcon}
          url="/ourServices/addService"
        />
        <UpdateHeading/>
        <Table data={services} />
        {/* {metadata?.totalResults > 8 && <BootyPagination metaData={metadata} />} */}
      </div>
    </>
  );
};

export default Blogs;
